
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M13 6.99H14.79C15.24 6.99 15.46 6.45 15.14 6.14L12.35 3.36C12.15 3.17 11.84 3.17 11.64 3.36L8.86003 6.14C8.54003 6.45 8.76003 6.99 9.21003 6.99H11V17.01H9.21003C8.76003 17.01 8.54003 17.55 8.86003 17.86L11.65 20.64C11.85 20.83 12.16 20.83 12.36 20.64L15.15 17.86C15.47 17.55 15.24 17.01 14.8 17.01H13V6.99Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-height`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconHeight

    ```js
    <b-new-b-icon-height />
    ```
</docs>


